<template>
  <div>
    <custom-actions show-back title="供应商编辑">
      <el-form class="form" v-loading='loading' :model="formData" :rules="rules" ref="form" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="formData.companyName" placeholder="请输入公司名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业统一信用代码" prop="businessLicense">
              <el-input v-model="formData.businessLicense" placeholder="请输入企业统一信用代码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人姓名" prop="legalName">
              <el-input v-model="formData.legalName" placeholder="请输入法人姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证号码" prop="legalId">
              <el-input v-model="formData.legalId" placeholder="请输入法人身份证号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行开户行" prop="bankAccount">
              <el-input v-model="formData.bankAccount" placeholder="请输入银行开户行"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行开户账号" prop="bankNum">
              <el-input v-model="formData.bankNum" placeholder="请输入银行开户账号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="formData.contactPerson" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人号码" prop="contactNumber">
              <el-input v-model="formData.contactNumber" placeholder="请输入联系人号码"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="businessFile" label="营业执照(">
              <div class="row-wrap">
                <div class="images-wrap" v-if="formData.businessFile">
                  <i class="el-icon-error close-icon" @click="delImage('businessFile')"></i>
                  <el-image style="width: 100%; height: 100%" :src="formData.businessFile"
                    :preview-src-list="[formData.businessFile]" fit="cover" />
                </div>

                <el-upload class="upload-demo" v-else :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="res => handleSuccess(res, 'businessFile')" :before-upload="beforeUpload"
                  list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="taxCert" label="食品经营许可证">
              <div class="row-wrap">
                <div class="images-wrap" v-if="formData.taxCert">
                  <i class="el-icon-error close-icon" @click="delImage('taxCert')"></i>
                  <el-image style="width: 100%; height: 100%" :src="formData.taxCert"
                    :preview-src-list="[formData.taxCert]" fit="cover" />
                </div>

                <el-upload class="upload-demo" v-else :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="res => handleSuccess(res, 'taxCert')" :before-upload="beforeUpload"
                  list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="legalFileUp" label="法人身份证头像面">
              <div class="row-wrap">
                <div class="images-wrap" v-if="formData.legalFileUp">
                  <i class="el-icon-error close-icon" @click="delImage('legalFileUp')"></i>
                  <el-image style="width: 100%; height: 100%" :src="formData.legalFileUp"
                    :preview-src-list="[formData.legalFileUp]" fit="cover" />
                </div>

                <el-upload class="upload-demo" v-else :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="res => handleSuccess(res, 'legalFileUp')" :before-upload="beforeUpload"
                  list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="legalFileDe" label="法人身份证国徽面">
              <div class="row-wrap">
                <div class="images-wrap" v-if="formData.legalFileDe">
                  <i class="el-icon-error close-icon" @click="delImage('legalFileDe')"></i>
                  <el-image style="width: 100%; height: 100%" :src="formData.legalFileDe"
                    :preview-src-list="[formData.legalFileDe]" fit="cover" />
                </div>

                <el-upload class="upload-demo" v-else :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="res => handleSuccess(res, 'legalFileDe')" :before-upload="beforeUpload"
                  list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import { validIDCard, validUSCI } from '@/utils/validator.js'
export default {
  name: 'SupplierAdd',
  data() {
    return {
      loading: false,
      formData: {
        companyId: '', // 企业ID
        openId: '', // 注册人openID
        companyName: '', // 公司名称
        companyState: '', // 审批状态1审批中2已通过3已拒绝
        businessLicense: '', // 组织机构代码
        legalName: '', // 法人姓名
        legalId: '', // 法人身份证号码
        bankAccount: '', // 银行开户行
        bankNum: '', // 银行开户账号
        contactPerson: '', // 联系人
        contactNumber: '', // 联系号码
        businessFile: '', // 营业执照(文件)
        legalFileUp: '', // 法人身份证头像面
        legalFileDe: '', // 法人身份证国徽面
        taxCert: '', // 企业纳税证明(文件)
        isDel: '', // 是否删除，1为删除，0为未删除
        ctime: '', // 创建时间
        recordList: [] // 审批记录
      },
      rules: {
        companyName: [{ required: true, message: '请输入公司名称' }],
        businessLicense: [
          { required: true, message: '请输入企业统一信用代码' },
          { pattern: validUSCI, message: '请输入正确的统一信用代码' }
        ],
        legalName: [{ required: true, message: '请输入法人姓名' }],
        legalId: [
          { required: true, message: '请输入法人身份证号码' },
          { pattern: validIDCard, message: '请输入正确的身份证号码' }
        ],
        bankAccount: [{ required: true, message: '请输入银行开户行' }],
        bankNum: [{ required: true, message: '请输入银行开户账号' }],
        contactPerson: [{ required: true, message: '请输入联系人' }],
        contactNumber: [{ required: true, message: '请输入联系号码' }],
        businessFile: [{ required: true, message: '请上传营业执照' }],
        legalFileUp: [{ required: true, message: '请上传法人身份证头像面' }],
        legalFileDe: [{ required: true, message: '请上传法人身份证国徽面' }],
        taxCert: [{ required: true, message: '请上传食品经营许可证' }]
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    companyId() {
      return this.$route.query.companyId
    },
    fileUrls() {
      return this.form.fileList.map(file => {
        return file.filePrefix + file.fileUrl
      })
    },
    formatFileList() {
      return this.form.fileList.map(file => {
        return {
          name: file.fileName,
          url: file.filePrefix + file.fileUrl
        }
      })
    },
    imageList() {
      return this.formatFileList.filter(item => {
        return item.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(item.name.substring(item.name.lastIndexOf('.')).toLowerCase())
      })
    }

  },
  created() {
    if (this.companyId) {
      this.loadDetails()
    }
  },
  methods: {
    delImage(filed) {
      console.log('field', filed)
      this.formData[filed] = ''
    },
    handleSuccess(res, field) {
      this.formData[field] = res.data.filePrefix + res.data.fileUrl
    },
    onPreview(file) {
      if (file.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())) {
        this.currentImageIndex = this.imageList.findIndex(url => url.name === file.name)
        this.dialogVisible = true
      } else {
        window.open(file.url, '_blank')
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },
    loadDetails() {
      this.loading = true
      this.$axios.get(this.$apis.supplier.selectYcCompanyInfoByCompanyId, {
        companyId: this.companyId
      }).then(res => {
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.$axios.post(this.$apis.supplier.updateYcCompanyInfo, this.formData).then(res => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader,
.el-radio-group,
.el-input-number {
  max-width: 400px;
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
